module.exports = __webpack_public_path__ + "assets/hostingpage-1ab0f460b8667143c79ec3fb5b5604ef.png";


//////////////////
// WEBPACK FOOTER
// ./pages/Website/assets/hostingpage.png
// module id = 640
// module chunks = 0 1